import request from '@/utils/request'
import {baseUrl} from './baseUrl.js'



/**
 * 获取分享时的签名信息
 * @param data
 */
export function akShareSignature(data) {
    return request({
        url: baseUrl + '/wx/share/signature',
        method: 'post',
        data
    })
}


